import React, { useEffect, useRef, useState } from "react";
import fondateurs from "../../../images/Team/fondateurs.jpg";
import team from "../../../images/Team/team.jpg";
import "./Createurs.css";

function Brochure({
  title,
  names = [],
  text,
  image,
  alt,
  className = "",
  delayClass = "",
}) {
  const blockRef = useRef(null);
  const imageRef = useRef(null);

  const [isVisible, setIsVisible] = useState(false);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const currentBlock = blockRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (currentBlock) observer.observe(currentBlock);

    return () => {
      if (currentBlock) observer.unobserve(currentBlock);
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!imageRef.current) return;

      const rect = imageRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.top < windowHeight && rect.bottom > 0) {
        const progress = (windowHeight - rect.top) / (windowHeight + rect.height);
        const move = (progress - 0.5) * 24;
        setOffset(move);
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      ref={blockRef}
      className={`Createurs_brochure ${className} ${isVisible ? "show-block" : ""}`}
    >
      <div className="Createurs_brochureInner">
        <div className={`Createurs_verticalTitle reveal ${delayClass} delay-1`}>
          <span>{title}</span>
        </div>

        <div className="Createurs_block">
          {names.length > 0 && (
            <div className={`Createurs_topNames reveal ${delayClass} delay-2`}>
              {names.map((name, index) => (
                <span key={index}>{name}</span>
              ))}
            </div>
          )}

          {text && (
            <p className={`Createurs_blockText reveal ${delayClass} delay-2`}>
              {text}
            </p>
          )}

          <div className={`Createurs_photoWrap reveal ${delayClass} delay-3`}>
            <img
              ref={imageRef}
              src={image}
              alt={alt}
              className="Createurs_photo"
              style={{ transform: `translateY(${offset}px) scale(1.04)` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Createurs() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentSection = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.12,
      }
    );

    if (currentSection) observer.observe(currentSection);

    return () => {
      if (currentSection) observer.unobserve(currentSection);
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`Createurs ${isVisible ? "show" : ""}`}
    >
      <div className="Createurs_container">
        <div className="Createurs_top">
          <p className="Createurs_kicker reveal intro-1">Elements Group</p>

          <h2 className="Createurs_quote">
            <span className="reveal intro-2">Notre devise :</span>
            <span className="reveal intro-3">
              “La création d’un ensemble d’éléments de valeur unique”
            </span>
          </h2>

          <p className="Createurs_text">
            <span className="reveal intro-4">
              Nous sommes fiers de partager avec vous notre passion pour  les
             cuisines uniques, où chaque projet est une collaboration,et chaque résultat
            </span>
            <span className="reveal intro-5">
               est le reflet d&apos;une vision partagée.
            </span>
          </p>

          <div className="Createurs_footerNote reveal intro-6">
            <h4>M. Hechem et M. Mohamed</h4>
            <h5>Dirigeants de ELEMENTS</h5>
          </div>
        </div>

        <div className="Createurs_brochuresGroup">
          <Brochure
            title="FONDATEURS D’ELEMENTS"
            names={[ "Mr. Mohamed Trabelsi","Mr. Hechem Trabelsi"]}
            image={fondateurs}
            alt="M. Hechem et M. Mohamed Trabelsi"
            delayClass="founders"
          />

          <Brochure
            title="TEAM WORK"
            text="Se réunir est un début, rester ensemble est un progrès, travailler ensemble est 
la réussite. La vraie réussite d'une équipe c'est d’assurer la compétitivité dans 
la pérennité La réussite appartient tout le monde. C'est au travail d'équipe 
qu'en revient le mérite."
            image={team}
            alt="L’équipe Elements"
            className="Createurs_brochureTeam"
            delayClass="team"
          />
        </div>
      </div>
    </section>
  );
}